import React from 'react';
// import PropTypes from 'prop-types';
import BaseButton from './BaseButton';
import useModal from '../modal_refactor/useModal';

const ModalButton = React.forwardRef((props, ref) => {
  const [, modalDispatch] = useModal();

  return (
    <BaseButton
      ref={ref}
      onClick={() => modalDispatch({ type: 'toggle' })}
      {...props}
    />
  );
});

export default ModalButton;
